// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2GMtj","info":"Note_info__3mwuE","note":"Note_note__39EmO","actions":"Note_actions__8pRMT"};